import request from '@/request';
import env from "@/utils/env";
import localStorage from "@/utils/localStorage";

export default {
  /**
   * 明星ip活动查询接口
   */
  331673: (actid) => {
    return request.ticket({
      url: '/gateway/gtgj/act',
      data: Object.assign({
        pid: 331673,
        actid
      }),
      sidFields: ['uid', 'pid']
    })
  },
  /**
   * 明星ip领取免费会员
   */
  331674: (actid) => {
    let sourcePlat = "";
    let ptid = localStorage.get("ptid") || "";

    if (env.isNative) {
      sourcePlat = "app";
    } else if (env.isWeixin) {
      sourcePlat = "wechat";
    } else if (ptid) {
      sourcePlat = ptid;
    }

    return request.ticket({
      url: '/gateway/gtgj/act',
      auth: 'yes',
      data: Object.assign({
        pid: 331674,
        actid,
        sourcePlat
      }),
      sidFields: ['uid', 'pid']
    })
  }
}



// WEBPACK FOOTER //
// ./src/projects/vipCard/service/receiveFree.js